/**
 * Push provider identity. Customer.io is the only push SDK in the build; the id is
 * kept so click events and analytics still say which provider delivered a tap.
 */

export const PUSH_PROVIDER_IDS = ['customerio'] as const

export type PushProviderId = (typeof PUSH_PROVIDER_IDS)[number]

/**
 * Analytics `source` for a notification tap. Pinned to the strings the existing
 * dashboards already query — do not rename these to match the provider ids.
 */
export const PUSH_ANALYTICS_SOURCE: Record<PushProviderId, string> = {
  customerio: 'CustomerIOPush'
}
